const isDeleteUndoAction = (action) =>
  action?.type === 'DELETE_TASK' || action?.type === 'DELETE_TASKS';

/**
 * Extends the most recent delete undo entry so undo also restores pre-compaction layout.
 */
export function attachLayoutUndoToDelete({
  wrapLastUndoAction,
  applyTaskPositions,
  setCustomPositions,
  originalPositions,
  compactedPositions,
}) {
  if (!wrapLastUndoAction || !originalPositions || Object.keys(originalPositions).length === 0) {
    return false;
  }

  const applyPositions = (posMap) => {
    if (!posMap || Object.keys(posMap).length === 0) return;
    applyTaskPositions?.(posMap);
    setCustomPositions?.((prev) => {
      const next = { ...prev };
      Object.entries(posMap).forEach(([id, pos]) => {
        if (pos && typeof pos.x === 'number' && typeof pos.y === 'number') {
          next[id] = { x: pos.x, y: pos.y };
        }
      });
      return next;
    });
  };

  return wrapLastUndoAction(isDeleteUndoAction, ({ originalUndo, originalRedo }) => ({
    undo: () => {
      applyPositions(originalPositions);
      originalUndo();
    },
    redo: () => {
      originalRedo();
      applyPositions(compactedPositions);
    },
  }));
}
